import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const copy = {
  en: {
    confirmTitle: 'Confirming your Nimny updates',
    unsubscribeTitle: 'Weekly Nimny updates',
    unsubscribeBody: 'You can stop the weekly story email at any time.',
    unsubscribeButton: 'Unsubscribe',
    working: 'One quiet moment…',
    home: 'Back to Nimny',
    error: 'This link could not be completed. Please return to Nimny and try again.',
  },
  es: {
    confirmTitle: 'Confirmando las novedades de Nimny',
    unsubscribeTitle: 'Novedades semanales de Nimny',
    unsubscribeBody: 'Puedes detener el correo semanal de historias en cualquier momento.',
    unsubscribeButton: 'Cancelar suscripción',
    working: 'Un momento…',
    home: 'Volver a Nimny',
    error: 'No se pudo completar este enlace. Vuelve a Nimny e inténtalo de nuevo.',
  },
  ru: {
    confirmTitle: 'Подтверждаем новости Нимни',
    unsubscribeTitle: 'Еженедельные новости Нимни',
    unsubscribeBody: 'Вы можете в любой момент остановить еженедельные письма с историями.',
    unsubscribeButton: 'Отписаться',
    working: 'Одну тихую минутку…',
    home: 'Вернуться к Нимни',
    error: 'Не удалось выполнить действие по этой ссылке. Вернитесь на сайт Нимни и попробуйте снова.',
  },
};

const preferredLanguage = () => {
  const language = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return copy[language] ? language : 'en';
};

const SubscriptionActionPage = ({ action }) => {
  const { token } = useParams();
  const language = useMemo(preferredLanguage, []);
  const text = copy[language];
  const [state, setState] = useState(action === 'confirm' ? 'working' : 'ready');
  const [message, setMessage] = useState('');

  useEffect(() => {
    document.title = action === 'confirm' ? text.confirmTitle : text.unsubscribeTitle;
    let robots = document.querySelector('meta[name="robots"]');
    const created = !robots;
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    const previous = robots?.getAttribute('content');
    robots.setAttribute('content', 'noindex,nofollow,noarchive');
    let referrer = document.querySelector('meta[name="referrer"]');
    const createdReferrer = !referrer;
    if (!referrer) {
      referrer = document.createElement('meta');
      referrer.setAttribute('name', 'referrer');
      document.head.appendChild(referrer);
    }
    const previousReferrer = referrer?.getAttribute('content');
    referrer.setAttribute('content', 'no-referrer');
    return () => {
      if (created) robots.remove();
      else if (previous) robots.setAttribute('content', previous);
      if (createdReferrer) referrer.remove();
      else if (previousReferrer) referrer.setAttribute('content', previousReferrer);
    };
  }, [action, text]);

  const perform = async () => {
    setState('working');
    try {
      const response = await axios.post(`${API}/subscriptions/${action}/${token}`);
      setMessage(response.data.message);
      setState('success');
    } catch (error) {
      setMessage(error.response?.data?.detail || text.error);
      setState('error');
    }
  };

  useEffect(() => {
    if (action === 'confirm') perform();
    // The token and action define this one-time page operation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, token]);

  return (
    <main className="min-h-screen bg-[#111024] px-5 py-16 text-[#f5ebe0] flex items-center justify-center">
      <section className="w-full max-w-xl rounded-3xl border border-amber-200/15 bg-[#f5ebe0]/[0.06] p-7 text-center shadow-2xl md:p-10">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#c9a87c]">Nimny Night Notes</p>
        <h1 className="mb-4 font-serif text-3xl text-[#f5ebe0]">
          {action === 'confirm' ? text.confirmTitle : text.unsubscribeTitle}
        </h1>
        {state === 'ready' && <p className="mb-7 text-[#ded5cc]">{text.unsubscribeBody}</p>}
        {state === 'working' && <p className="mb-7 text-[#ded5cc]">{text.working}</p>}
        {(state === 'success' || state === 'error') && (
          <p className={`mb-7 ${state === 'error' ? 'text-red-200' : 'text-[#ded5cc]'}`}>{message}</p>
        )}
        {state === 'ready' && action === 'unsubscribe' && (
          <button
            type="button"
            onClick={perform}
            className="mb-5 min-h-[48px] rounded-xl bg-[#c9a87c] px-7 py-3 font-semibold text-[#171421] hover:bg-[#d4b896]"
          >
            {text.unsubscribeButton}
          </button>
        )}
        <div>
          <Link className="inline-flex min-h-[44px] items-center text-[#e1c7a3] underline-offset-4 hover:underline" to="/">
            {text.home}
          </Link>
        </div>
      </section>
    </main>
  );
};

export default SubscriptionActionPage;

